export const isEmptyValue = (value) =>
  ['', null, undefined, '{}'].includes(value) === true ||
  (Array.isArray(value) === true && value.length === 0) ||
  (typeof value === 'object' && Object.keys(value).length === 0);
